<template>
<footer class="footer">
        <div class="footer__widgets style-1">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-dev u-md-down-margin-b-40">
                        <div class="widget about">
                            <div class="widget__title">
                                   <div class="logo">
                                <a href="#"><img src="/src/assets/img/logo/logo-white.png" width="200" alt="Logo"></a>
                            </div>
                            <ul class="a-block u-margin-t-20">
                                <li class="mb-2"><h6><router-link :to="{ name:'impressum'}">Impressum</router-link></h6></li>
                                <li><hr class="hr-light-gray"/></li>
                                    <li>
                                        <h6>Adresa :</h6>
                                        <p><span>{{ contactInfo.address }}</span></p>
                                    </li>
                                    <li>
                                        <h6>E-mail adresa :</h6>
                                        <p> <span><a v-bind:href="`mailto:${contactInfo.email}`">{{ contactInfo.email }}</a></span></p>
                                    </li>
                                </ul>
                                  <div class="widget social">
                                 <ul class="social--circle social--color">
                                <li v-if="socialNetworks.facebookPage"><a class="social__facebook" v-bind:href="socialNetworks.facebookPage" target="_blank"><i class="fa fa-facebook"></i></a></li>
                                <li v-if="socialNetworks.twitterPage"><a class="social__twitter" v-bind:href="socialNetworks.twitterPage" target="_blank"><i class="fa fa-twitter"></i></a></li>
                                <li v-if="socialNetworks.instagramPage"><a class="social__instagram" v-bind:href="socialNetworks.instagramPage" target="_blank"><i class="fa fa-instagram"></i></a></li>
                                <li v-if="socialNetworks.youtubeChannel"><a class="social__youtube" v-bind:href="socialNetworks.youtubeChannel" target="_blank"><i class="fa fa-youtube"></i></a></li>
                            </ul>
                            </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-dev u-md-down-margin-b-40">
                        <div class="widget widget_menu">
                            <div class="widget__title">
                                <h4>Najpopularnije</h4>
                                <ul>
                                    <li v-for="(category, i) in popularCategories" :key="i">
                                          <router-link :to="{ name: 'category', params: { category: category.categorySearchCode, subcategory: category.searchCode } }">
                                            {{ category.name }}
                                          </router-link>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-dev u-sm-down-margin-b-40">
                        <div class="widget bolt-post widget--border-box cat-trending single-cat">
                            <div class="widget__title">
                                <h4>Foto</h4>
                                <ul class="posts-wrap">
                                    <li v-for="(post, i) in photoPosts" :key="i">
                                    <figure v-bind:style="{borderLeft: '2px solid ' + post.postCategoryBorderColor}">
                                         <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">
                                        <img v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                                    </figure>
                                    <div class="post-content">
                                        <h6 class="post-title">
                                             <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">
                                                {{ post.shortTitle != null? post.shortTitle : post.title }}
                                            </router-link>
                                        </h6>
                                        <div class="post-meta">
                                           <time><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }} </time>
                                        </div>
                                    </div>                
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                                <!-- <div class="r-dev"></div>

                <div class="row">
                    <div class="col-md-4 col-sm-5">
                        <div class="widget social">
                            <div class="logo">
                                <a href="#"><img src="/src/assets/img/logo/logo-white.png" width="200" alt=""></a>
                            </div>
                            <ul class="social--circle social--color">
                                <li v-if="socialNetworks.facebookPage"><a class="social__facebook" v-bind:href="socialNetworks.facebookPage" target="_blank"><i class="fa fa-facebook"></i></a></li>
                                <li v-if="socialNetworks.twitterPage"><a class="social__twitter" v-bind:href="socialNetworks.twitterPage" target="_blank"><i class="fa fa-twitter"></i></a></li>
                                <li v-if="socialNetworks.instagramPage"><a class="social__instagram" v-bind:href="socialNetworks.instagramPage" target="_blank"><i class="fa fa-instagram"></i></a></li>
                                <li v-if="socialNetworks.youtubeChannel"><a class="social__youtube" v-bind:href="socialNetworks.youtubeChannel" target="_blank"><i class="fa fa-youtube"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-7 d-none d-sm-block">
                        <div class="widget banner">
                            <div class="banner__inner">
                                <a href="#"><img src="img/banner-770x100.jpg" alt=""></a>
                            </div>
                        </div>
                    </div>

                </div> -->
            </div>
        </div>
        <div class="footer__end footer__end--dark">
            <div class="container">
                 <nav class="footer__nav">
                    <ul>
                        <li><router-link :to="{ name:'o-nama'}">O nama</router-link></li>
                        <li><router-link :to="{ name:'marketing'}">Marketing</router-link></li>
                        <li><router-link :to="{ name:'pravila-privatnosti'}">Pravila privatnosti</router-link></li>
                        <li><router-link :to="{ name:'kontakt'}">Kontakt</router-link></li>
                    </ul>
                </nav>
                <div class="footer__copyright u-padding-t-15">
                    <p class="u-font13">© {{ new Date().getFullYear() }} Politicki.ba</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { AboutService, CategoriesService, NewsService } from '../common/api.service'

    export default {
        name: "Footer",
        data() {
            return {
                contactInfo: {},
                popularCategories: [],
                photoPosts: [],
                socialNetworks: {}
            }
        }, 
        created() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {    
                AboutService.getContactInfo().then(res => { this.contactInfo = res.data});
                CategoriesService.getPopular().then(res => this.popularCategories = res.data);
                NewsService.getPhotoPosts(0, 4).then(res => this.photoPosts = res.data);
                AboutService.getSocialNetworksInfo().then(res => this.socialNetworks = res.data);
            }
        }
    }
</script>

<style scoped>
    .widget--border-box .widget__title {
        height: auto;
        padding-left: 0px;
        border: none;
        border-left:  none;
    }

    .widget--border-box.single-cat .posts-wrap {
        padding: 0px;
        border-right: none;
        border-bottom: none;
        border-left: none;
    }   


    .widget--border-box .widget__title h4 {
        margin: 0;
        line-height: 23px;
        margin-bottom: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue